import logger from "../../../utils/logger";
import React, { useState, Fragment } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Input,
  FormFeedback,
  FormGroup,
} from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { requestPayments } from "../../../slices/apps/orderSlice";

// Formik & Yup
import * as Yup from "yup";
import { useFormik } from "formik";

// Flatpickr
import Flatpickr from "react-flatpickr";
import { Turkish } from "flatpickr/dist/l10n/tr";

const RequestPaymentModal = ({ ids }) => {
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);

  const { requestPaymentsLoading } = useSelector(
    (state) => ({
      requestPaymentsLoading: state.order.requestPaymentsLoading,
    }),
    shallowEqual
  );

  const validation = useFormik({
    initialValues: {
      invoiceNo: "",
      invoiceDate: "",
    },
    validationSchema: Yup.object({
      invoiceNo: Yup.string()
        .max(50, "Fatura numarası en fazla 50 karakter olabilir.")
        .required("Lütfen fatura numarasını giriniz."),
      invoiceDate: Yup.string().required("Lütfen fatura tarihini seçiniz."),
    }),
    onSubmit: async (values) => {
      try {
        const payload = {
          ids: ids,
          invoiceNo: values.invoiceNo,
          invoiceDate: values.invoiceDate,
        };

        await dispatch(requestPayments(payload)).unwrap();
        setModal(false);
      } catch (error) {
        logger.error("Ödeme talebi hatası:", error);
      }
    },
  });

  const toggle = () => {
    if (!modal) {
      validation.resetForm();
    }
    setModal(!modal);
  };

  const toggleWarning = () => {
    setWarningModal(!warningModal);
  };

  const handleOpenCheck = () => {
    if (!ids || ids.length === 0) {
      setWarningModal(true);
    } else {
      toggle();
    }
  };

  return (
    <Fragment>
      <Button
        className="btn btn-label"
        color="primary"
        type="button"
        onClick={handleOpenCheck}
      >
        <i className="ri-add-line label-icon align-middle me-2"></i> Talep
        Oluştur
      </Button>

      <Modal isOpen={warningModal} toggle={toggleWarning} centered>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <i className="ri-alert-line display-3 text-primary"></i>
            <div className="mt-2 pt-2 fs-15">
              <h4>Dikkat!</h4>
              <p className="text-muted mx-4 mb-0 fs-13">
                Lütfen aşağıdaki servis listesinden ödeme talep etmek
                istediğiniz satırları seçiniz.
              </p>
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <Button
              type="button"
              color="primary"
              className="btn-label w-sm"
              onClick={toggleWarning}
            >
              <i className="ri-check-line label-icon align-middle me-2"></i>
              Tamam
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modal} toggle={toggle} centered>
        <ModalHeader className="modal-title" toggle={toggle}></ModalHeader>

        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <i className="ri-send-plane-fill display-3 text-primary"></i>
            <div className="mt-2 pt-2 fs-15">
              <h4>Ödeme Talep Et</h4>
              <p className="text-muted mx-4 mb-4 fs-13">
                Lütfen fatura detaylarını giriniz.
              </p>
            </div>
          </div>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
            autoComplete="off"
          >
            <div className="mb-3">
              <FormGroup className="mb-3">
                <Label htmlFor="invoiceNo">Fatura No</Label>
                <Input
                  id="invoiceNo"
                  name="invoiceNo"
                  type="text"
                  placeholder="Fatura No"
                  maxLength={50}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.invoiceNo || ""}
                  invalid={
                    validation.touched.invoiceNo && validation.errors.invoiceNo
                      ? true
                      : false
                  }
                />
                {validation.touched.invoiceNo && validation.errors.invoiceNo ? (
                  <FormFeedback type="invalid">
                    {validation.errors.invoiceNo}
                  </FormFeedback>
                ) : null}
              </FormGroup>

              <FormGroup className="mb-3">
                <Label className="form-label">Fatura Tarihi</Label>
                <Flatpickr
                  className={`form-control ${validation.touched.invoiceDate &&
                      validation.errors.invoiceDate
                      ? "is-invalid"
                      : ""
                    }`}
                  options={{
                    dateFormat: "d.m.Y",
                    locale: { ...Turkish },
                  }}
                  value={
                    validation.values.invoiceDate
                      ? new Date(validation.values.invoiceDate)
                      : null
                  }
                  onChange={(date) => {
                    if (date && date.length > 0) {
                      validation.setFieldValue(
                        "invoiceDate",
                        date[0].toISOString()
                      );
                    }
                  }}
                  placeholder="Tarih Seçiniz"
                />
                {validation.touched.invoiceDate &&
                  validation.errors.invoiceDate && (
                    <div className="d-block invalid-feedback">
                      {validation.errors.invoiceDate}
                    </div>
                  )}
              </FormGroup>
            </div>

            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
              <Button
                type="button"
                color="danger"
                className="btn-label w-sm"
                onClick={toggle}
              >
                <i className="ri-close-line label-icon align-middle me-2"></i>
                Kapat
              </Button>

              <Button
                type="submit"
                color="primary"
                className="btn-label w-sm"
                disabled={requestPaymentsLoading}
              >
                <i className="ri-send-plane-fill label-icon align-middle me-2"></i>
                {requestPaymentsLoading
                  ? "Talep Ediliyor..."
                  : "Evet, Talep Et!"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default RequestPaymentModal;
